import { useEffect } from "react";

/** Mobile keyboards shrink the visual viewport even when 100dvh stays unchanged. */
export function useViewportHeight() {
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      // Native page zoom should keep its normal scrolling behavior.
      if (viewport && viewport.scale !== 1) return;
      document.documentElement.style.setProperty(
        "--app-height", `${viewport?.height ?? window.innerHeight}px`,
      );
    };
    update();
    viewport?.addEventListener("resize", update);
    window.addEventListener("resize", update);
    return () => {
      viewport?.removeEventListener("resize", update);
      window.removeEventListener("resize", update);
      document.documentElement.style.removeProperty("--app-height");
    };
  }, []);
}
